import { render, staticRenderFns } from "./FlightsMap.vue?vue&type=template&id=540097b7&scoped=true&"
import script from "./FlightsMap.vue?vue&type=script&lang=ts&"
export * from "./FlightsMap.vue?vue&type=script&lang=ts&"
import style0 from "./FlightsMap.vue?vue&type=style&index=0&id=540097b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540097b7",
  null
  
)

export default component.exports